import { createBrowserRouter, Navigate } from "react-router-dom";
import NavBar from "./components/common/Navbar";
import ProjectDetail from "./views/ProjectDetail";
import Resume from "./views/Resume";
import { MainPage } from "./views/Main";
import Projects from "./views/Projects";

import * as fullStackConstants from "./constants/resume";
import * as frontendConstants from "./constants/frontendResume";
import * as backendConstants from "./constants/backendResume";
import CoverLetterGenerator from "./views/CoverLetter";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <NavBar />,
    children: [
      { path: "/", element: <MainPage /> },
      { path: "/projects", element: <Projects /> },
      { path: "/project/:name", element: <ProjectDetail /> },
    ],
  },
  {
    path: "/resume",
    element: <Resume {...fullStackConstants} />,
  },
  {
    path: "/resume/frontend",
    element: <Resume {...frontendConstants} />,
  },
  {
    path: "/resume/backend",
    element: <Resume {...backendConstants} />,
  },
  {
    path: "/cover-letter",
    element: <CoverLetterGenerator />,
  },
  { path: "*", element: <Navigate to="/" /> },
]);
